"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MOONPAY_WITHDRAW_SEPA_COUNTRIES = exports.MOONPAY_WITHDRAW_AVAILABLE_COUNTRIES = exports.MOONPAY_WITHDRAW_UNAVAILABLE_STATES = exports.MOONPAY_UNAVAILABLE_COUNTRIES = exports.MOONPAY_UNAVAILABLE_STATES = void 0;
exports.MOONPAY_UNAVAILABLE_STATES = {
    LA: 'Louisiana',
};
exports.MOONPAY_UNAVAILABLE_COUNTRIES = {
    AFG: 'Afghanistan',
    ALB: 'Albania',
    BHS: 'Bahamas',
    BGD: 'Bangladesh',
    BRB: 'Barbados',
    BLR: 'Belarus',
    BOL: 'Bolivia',
    BWA: 'Botswana',
    BFA: 'Burkina Faso',
    KHM: 'Cambodia',
    CAN: 'Canada',
    CYM: 'Cayman Islands',
    CAF: 'Central African Republic',
    CHN: 'China',
    COD: 'Democratic Republic of the Congo',
    COG: 'Republic of the Congo',
    CIV: 'Ivory Coast',
    CUB: 'Cuba',
    ECU: 'Ecuador',
    GHA: 'Ghana',
    HTI: 'Haiti',
    ISL: 'Iceland',
    IRN: 'Iran',
    IRQ: 'Iraq',
    JAM: 'Jamaica',
    JPN: 'Japan',
    XKX: 'Kosovo',
    PRK: 'North Korea',
    LBR: 'Liberia',
    MLT: 'Malta',
    MUS: 'Mauritius',
    MNG: 'Mongolia',
    MAR: 'Morocco',
    MMR: 'Myanmar',
    NIC: 'Nicaragua',
    PAK: 'Pakistan',
    PAN: 'Panama',
    RUS: 'Russia',
    SEN: 'Senegal',
    SSD: 'South Sudan',
    SDN: 'Sudan',
    SYR: 'Syria',
    TTO: 'Trinidad and Tobago',
    UGA: 'Uganda',
    UKR: 'Ukraine',
    VGB: 'British Virgin Islands',
    VIR: 'U.S. Virgin Islands',
    VUT: 'Vanuatu',
    VEN: 'Venezuela',
    YEM: 'Yemen',
    ZWE: 'Zimbabwe',
};
exports.MOONPAY_WITHDRAW_UNAVAILABLE_STATES = {
    LA: 'Louisiana',
    NY: 'New York',
    TX: 'Texas',
};
exports.MOONPAY_WITHDRAW_AVAILABLE_COUNTRIES = {
    AND: 'Andorra',
    AIA: 'Anguilla',
    ATA: 'Antarctica',
    ABW: 'Aruba',
    AUT: 'Austria',
    BEL: 'Belgium',
    BMU: 'Bermuda',
    BGR: 'Bulgaria',
    CXR: 'Christmas Island',
    CCK: 'Cocos Islands',
    COK: 'Cook Islands',
    HRV: 'Croatia',
    CUW: 'Curacao',
    CYP: 'Cyprus',
    CZE: 'Czech Republic',
    DNK: 'Denmark',
    EST: 'Estonia',
    FLK: 'Falkland Islands',
    FRO: 'Faroe Islands',
    FIN: 'Finland',
    FRA: 'France',
    PYF: 'French Polynesia',
    DEU: 'Germany',
    GIB: 'Gibraltar',
    GRC: 'Greece',
    GRL: 'Greenland',
    GUM: 'Guam',
    GGY: 'Guernsey',
    HUN: 'Hungary',
    IRL: 'Ireland',
    IMN: 'Isle of Man',
    JEY: 'Jersey',
    LVA: 'Latvia',
    LIE: 'Liechtenstein',
    LTU: 'Lithuania',
    LUX: 'Luxembourg',
    MAC: 'Macau',
    MYT: 'Mayotte',
    MCO: 'Monaco',
    MSR: 'Montserrat',
    NLD: 'Netherlands',
    ANT: 'Netherlands Antilles',
    NCL: 'New Caledonia',
    NIU: 'Niue',
    MNP: 'Northern Mariana Islands',
    NOR: 'Norway',
    PCN: 'Pitcairn',
    POL: 'Poland',
    PRT: 'Portugal',
    PRI: 'Puerto Rico',
    REU: 'Reunion',
    BLM: 'Saint Barthelemy',
    SHN: 'Saint Helena',
    MAF: 'Saint Martin',
    SPM: 'Saint Pierre and Miquelon',
    SMR: 'San Marino',
    SXM: 'Sint Maarten',
    SVK: 'Slovakia',
    SVN: 'Slovenia',
    KOR: 'South Korea',
    ESP: 'Spain',
    SJM: 'Svalbard and Jan Mayen',
    SWE: 'Sweden',
    CHE: 'Switzerland',
    TKL: 'Tokelau',
    TCA: 'Turks and Caicos Islands',
    GBR: 'United Kingdom',
    USA: 'United States',
    VAT: 'Vatican',
    WLF: 'Wallis and Futuna',
};
exports.MOONPAY_WITHDRAW_SEPA_COUNTRIES = {
    AUT: 'Austria',
    BEL: 'Belgium',
    BGR: 'Bulgaria',
    HRV: 'Croatia',
    CYP: 'Cyprus',
    CZE: 'Czech Republic',
    DNK: 'Denmark',
    EST: 'Estonia',
    FIN: 'Finland',
    FRA: 'France',
    DEU: 'Germany',
    GRC: 'Greece',
    HUN: 'Hungary',
    IRL: 'Ireland',
    LVA: 'Latvia',
    LIE: 'Liechtenstein',
    LTU: 'Lithuania',
    LUX: 'Luxembourg',
    NLD: 'Netherlands',
    NOR: 'Norway',
    POL: 'Poland',
    PRT: 'Portugal',
    SVK: 'Slovakia',
    SVN: 'Slovenia',
    ESP: 'Spain',
    SWE: 'Sweden',
};
